import bigcommerceHelpers from 'Platforms/bigcommerce/helpers';
import shopifyHelpers from 'Platforms/shopify/helpers';
import stringHelpers from 'Utils/string';

window.Convermax.Shopify = {
  ...(window.Convermax.Shopify || {}),
  ...shopifyHelpers,
};

window.Convermax.BigCommerce = {
  ...(window.Convermax.BigCommerce || {}),
  ...bigcommerceHelpers,
};

window.Convermax.helpers = {
  ...(window.Convermax.helpers || {}),
  ...stringHelpers,
};

// Safe localStorage proxy for use in store config files.
// Accessing window.localStorage directly throws a SecurityError in some environments
// (cross-origin iframes, Safari ITP, browsers with strict privacy settings).
// Store config.js files must use window.Convermax.localStorage instead of window.localStorage
// so that errors are silently swallowed and the rest of the page continues to work.
window.Convermax.localStorage = {
  getItem(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value);
    } catch {}
  },
  removeItem(key: string): void {
    try {
      window.localStorage.removeItem(key);
    } catch {}
  },
};
